import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { LargeForeignField } from './ForeignField';
import { setSelectedConjunto } from '../reducers/commonSlice';

function ConjuntoSelector(props) {
    const { onChange } = props;

    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const [selConjunto, setSelConjunto] = useState();

    const { t } = useTranslation();
    const dispatch = useDispatch();

    if (logguedUserData.isAdmin) {
        return (
            <div className='sp-btw'>
                <div>{t("Conjunto")}: {selConjunto}</div>
                <LargeForeignField
                    prefix='conjunto_selector'
                    defaultValue=''
                    config={
                        {
                            dbname: "conjunto_selector",
                            foreign: {
                                table: "conjunto"
                            },
                            onChange: (dbname, conjuntoId, selName) => {
                                setSelConjunto(selName);
                                if (onChange) {
                                    onChange(dbname, conjuntoId, selName);
                                } else {
                                    dispatch(setSelectedConjunto(conjuntoId));
                                }
                            }
                        }
                    }
                />
            </div>
        )
    }

    return (
        <div>
            {
                (!logguedUserData?.conjuntos || logguedUserData?.conjuntos.length === 0) &&
                <div>{t("NO_RELATED_UNITY")}</div>
            }
            {
                logguedUserData?.conjuntos.length === 1 &&
                <div>{t("Conjunto:")} {logguedUserData?.conjuntos[0].nombre}</div>
            }
            {
                logguedUserData?.conjuntos.length > 1 &&
                <div>
                    <label htmlFor='seleccion_conjunto' className="col-md-3 col-form-label">{t("seleccion_conjunto")}</label>
                    <div className="col-md-9">
                        <select
                            className="form-select"
                            id='seleccion_conjunto'
                            placeholder={t("seleccion_conjunto")}
                            onChange={(ev) => { dispatch(setSelectedConjunto(ev.target.value)) }}
                            value={logguedUserData?.selConjunto || ''}
                        >
                            {
                                logguedUserData?.conjuntos?.map(fo => (
                                    <option value={fo.id}>{fo.nombre}</option>
                                ))
                            }
                        </select>
                    </div>
                </div>
            }
        </div>
    );
}

export default ConjuntoSelector;